import type { NextPage } from 'next';
import { AuthLayout } from '@layouts/AuthLayout';
import { Marketplace } from '@components/Marketplace';
import { useUserProfile } from '@hooks/useUserProfile';
import { BlackBanner } from '@components/BlackBanner';

const AffiliateMarketplacePage: NextPage = () => {
  return (
    <AuthLayout userType="affiliate" coloredBorder navSelected="Marketplace">
      <AffiliateMarketplace />
    </AuthLayout>
  );
};

function AffiliateMarketplace() {
  const { data: dataUserProfile } = useUserProfile();

  return (
    <div className="pb-20">
      {dataUserProfile && !dataUserProfile.nickname && (
        <div className="mt-4">
          <BlackBanner
            title="Welcome to the Marketplace!"
            description="Fill out your profile to get started."
            button={{
              text: 'Get Started',
              link: {
                href: '/affiliate/profile',
              },
            }}
          />
        </div>
      )}

      <Marketplace />
    </div>
  );
}

export default AffiliateMarketplacePage;
